module.exports = __webpack_public_path__ + "img/dingzhi.eadaa79f.png";